// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — mode-selector.consts.classic.js, новая — mode-selector.consts.cp.js
import { isCp } from 'libs/design';
import * as classic from './mode-selector.consts.classic';
import * as cp from './mode-selector.consts.cp';

export const helpItems = isCp ? cp.helpItems : classic.helpItems;
export const modes = isCp ? cp.modes : classic.modes;
export const modesButtons = isCp ? cp.modesButtons : classic.modesButtons;
